import { createSelector } from "reselect";
import { values } from "lodash";
//EXTRACT THE PART OF THE STATE
const getData = state => state.data.houseType;

const getHouseType = createSelector(getData, houseType => values(houseType));

export default getHouseType;



// WEBPACK FOOTER //
// ./src/_selectors/dataSelectors/getHouseType.js